import React, { Component } from "react";
import { Table } from "react-bootstrap";
import Select2 from "../../../utilities/Form/Select2";
import InputNumber from "../../../utilities/Form/InputNumber";

import cookieManager from "../../../../utils/cookieManager";
import i18n from "../../../../i18n";
import DatePickerCustom from "../../../utilities/Form/datepicker";
const token = cookieManager.getUserToken();
const mystyle = {
  height: '100%',
  width: 1,
  backgroundColor: '#909090',
};

export class FormReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
       ...this.state, // agar form & lainnya tetap ada
      recordQtyMap: {},
      form: {
        Return: [],
        Retur: [],
        ItemRetur: [],
        Header: {},
        
      },
      date: new Date(),
      dateReturn: new Date(),
      dataRetur: [],
      unit: [],
      convert: 0,
      idSales: null,
      idTakingGood: null,
      update: 0,
      add: 0,
      count:0,
      updateRetur: 0,
      show: false,
      status: 1,
      set: 0,
      totalItem: 0,
      arrayDetail: [],
      arrayRetur: [],
      arrayTotal: [],
      isUpdate: 0,
    };
    this.formConvertion = React.createRef();
    this.handler = this.handler.bind(this);
    this.runSubmit = this.runSubmit.bind(this);
    this.handlerDateTime = this.handlerDateTime.bind(this);
    // this.handlerInputArray = this.handlerInputArray.bind(this);

  }


  handler(e) {
    var key = e.target.name;
    var value = e.target.value;
    this.setState({
      [key]: value,
    });
  }

  handlerSelectArray(e, id, i, arrayname) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    if (e == null) {
      objectss[id.name] = null;
    } else {
      objectss[id.name] = e;
    }
    this.setState(arr);
  }

  runSubmit() {
    const detail = this.state.arrayDetail;
    const retur = this.state.arrayRetur;
    const data = this.state.dataRetur;

    const Header = {
      date: moment(this.state.date).format('YYYY-MM-DD'),
      returnDate: moment(this.state.dateReturn).format('YYYY-MM-DD'),
      idTakingGood: this.state.idTakingGood,
      idSales: this.state.idSales
    }

    let saveData = [];
    let saveRetur = [];
    let saveItemRetur = [];
    let total = 0;

    for (var i = 0; i < retur.length; i++) {
      saveRetur.push(retur[i]);
    }

    for (var i = 0; i < data.length; i++) {
      saveItemRetur.push(data[i]);
    }

    for (var i = 0; i < detail.length; i++) {
      saveData.push(detail[i]);
      if (detail[i].convertReturn == (detail[i].convert - detail[i].total_sell)) {
        total = 0;
      } else {
        total += 1;
      }
    }

    if (total == 0) {
      this.state.form.Return = saveData;
      this.state.form.Retur = saveRetur;
      this.state.form.ItemRetur = saveItemRetur;
      this.state.form.Header = Header;
      this.state.form.status = true

    } else {
      this.state.form.status = false
    }
    return this.state.form;
  }

  //CONVERTION
  setConvertion(detail, index, array, key) {
    if (detail.itemValue != null) {
      let choose = {
        unitList: detail.itemValue.unit,
        qty: detail.itemValue.lastStok,
        convertionDetail: detail.convertionDetail,
        index: index,
        key: key,
        array: array,
      };
      this.setState({ itemChoose: choose, modalDetail: true });
    }

  }
  saveConvertion(status) {
    if (status) {
      let result = this.formConvertion.current.runSubmit();
      if (result != null) {
        const arr = [...this.state[this.state.itemChoose.array]];
        const objectss = arr[this.state.itemChoose.index];
        objectss[this.state.itemChoose.key] = result.qtyUse;
        objectss["convertionDetail"] = result.detail;
        this.setState(arr);
        this.setState({ modalDetail: false });
      }
    } else {
      this.setState({ modalDetail: false });
    }
  }

  handlerDateTime(e, name) {
    var key = name;
    var value = e
    this.setState({
      [key]: value
    })
  }

  handlerInputArray(e, name, i, arrayname, qty, p, id) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    var value = parseInt(e);

    if (!objectss['cons']) objectss['cons'] = {};
      objectss['cons'][p] = value * parseInt(qty);
    if (!objectss['return']) objectss['return'] = [];
    if (!objectss['return'][p]) objectss['return'][p] = {}; 

    objectss['return'][p][name] = value;
    objectss['return'][p]['qty'] = value;
    objectss['return'][p]['id'] = id;
    
    this.setState({ [arrayname]: arr },()=>this.calculate(i, name, value, p , id));
    
  }

  handlerInputArrayRetur(e, name, i, arrayname, qty, p, id) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    var value = parseInt(e);

    objectss['cons'][p] = value * parseInt(qty);
    objectss['retur'][p][name] = value;
    objectss['retur'][p]["qty"] = value;
    objectss['retur'][p]['id'] = id;
    this.calculateRetur(i, name, value, p);

  }


  calculate(i, name, value, p, id) {
    let total = 0;

    const detail = this.state.arrayDetail[i];
    const arrTotal = this.state.arrayTotal;

    const data = detail.cons
    if (data != null && data != '') {
      for (var a = 0; a < data.length; a++) {
        total += data[a] ?? 0;
      }
    }
    

    if (total <= (detail['total_item'] - detail['total_sell'])) {
      detail['convertReturn'] = total;
      this.setState(detail);

    } else {
      this.alertError('INFO', 'Total Kembali Harus Sama Dengan Total (Ambil - Penjualan)', 'info');

      detail['return'][p][name] = 0;
      detail['return'][p]["qty"] = 0;
      detail['cons'][p] = 0;

      this.setState(detail,()=>this.calculateReturnAll(detail));

    }
  }

  calculateReturnAll(detail){
      let  total = 0
      const data = detail.cons
      if (data != null && data != '') {
        for (var a = 0; a < data.length; a++) {
          total += data[a] == null ? 0 : data[a];
        }

      detail['convertReturn'] = total;

      }
  }

  calculateRetur(i, name, value, p) {
    let total = 0;

    const detail = this.state.arrayRetur[i];

    const data = detail.cons
    if (data != null && data != '') {
      for (var a = 0; a < data.length; a++) {
        total += data[a] == null ? 0 : data[a];
      }
    }
    if (total <= (detail['convert'])) {
      detail['convertRetur'] = total;
    } else {
      this.alertError('INFO', 'Total Barang Retur Tidak Boleh Melebihi', 'info');
      detail['retur'][p][name] = 0;
      detail['retur'][p]["qty"] = 0;
      detail['convertRetur'] = 0;
    }
    this.setState(detail, () => this.calculateAll());
  }

  calculateAll() {
    let totalDetail = 0;
    let totalRetur = 0;
    const retur = this.state.arrayRetur;
    const detail = this.state.arrayDetail;
    let array = [];

    for (var a = 0; a < detail.length; a++) {
      array.push({ item: detail[a].id_item, qty: detail[a].cons })
    }

    // for (var a = 0; a < dataRetur.length; a++) {
    //   totalRetur += dataRetur[a] == null ? 0 : dataRetur[a];
    // }
  }

  handlerCurrencyArray(e, name, i, arrayname) {
    const arr = [...this.state[arrayname]];
    const objectss = arr[i];
    objectss[name] = e;
    this.setState(arr);
  }

  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }

  alertError(title, message, icon, i) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }

  inputReturn(arrayname, name, id, val, i, p, qty){
    const arr = [...this.state[arrayname]];  // clone array biar aman
    const objectss = { ...arr[i] };          // clone object biar aman
     // var value = parseInt(val);

    if (!objectss['return']) objectss['return'] = [];
    if (!objectss['return'][p]) objectss['return'][p] = {};
    if (!objectss['cons']) objectss['cons'] = {};
    // if (!objectss['cons'][p]) objectss['cons'][p] = {};
    
    objectss['cons'][p] = val * parseInt(qty);
    objectss['return'][p][name] = val;
    objectss['return'][p]['qty'] = val;
    objectss['return'][p]['id'] = id;
    arr[i] = objectss;
    this.setState({ [arrayname]: arr });
    
    // objectss['cons'][p] = value * parseInt(qty);
   
  }

  addtoArray(arr,unit){
      arr.forEach((row, i) => {
          const array = row.detail.map(d => parseInt(d.id));
          const arrDetQty = Object.fromEntries(
                      row.item_detail.map(d => [d.idUnit, parseInt(d.qty)])
                    );

          Object.assign(row, {
              index: i,
              convertReturn: row.record_convert!=0? row.record_convert:0,
              return: this.state.unit.map(() => ({})),
              cons: [],
              warehouse: [],
            });
        {unit.map((nameUnit, p) => {
            const bit = nameUnit.value;
            const back = row["record"]?.find(item => item.unit === bit)?.qty ?? 0;
            const idx = array.indexOf(nameUnit.value);

            const qty = arrDetQty[nameUnit.value] ?? 0;
            this.inputReturn('arrayDetail', nameUnit?.label, bit, back, row.index, p, qty)
        })}

      });
  }

   setNewList(){
      const { data } = this.props;
      const { unit, update, set, recordQtyMap, count } = this.state;
      const html = [];
      let no = 1;
     
      const itemUnit = unit.map(u => ({ id: u.value }));

      if (data && data.return?.length > 0) {
        
        if(count === 0){
          // this.addtoArray(this.state.arrayDetail,unit);
          this.setState({
            arrayDetail: data.return,
            count: 1
          },() => {
          this.addtoArray(data.return, unit);}
        );
        }
        
        this.state.arrayDetail.forEach((row, i) => {
          // if (update === 0) {
          //   Object.assign(row, {
          //     index: i,
          //     convertReturn: row.record_convert!=0? row.record_convert:0,
          //     // return: this.state.unit.map(() => ({})),
          //     cons: [],
          //     warehouse: [],
          //   });
          // }

          if (set === 0) {
            this.state.idSales = row.id_sales;
            this.state.idTakingGood = row.id;
            this.state.set = 1;
          }

          const arr = row.detail.map(d => parseInt(d.id));
          const arrQty = row.detail.map(d => parseInt(d.qty));
          const arrDet = row.item_detail.map(d => parseInt(d.idUnit));
          const arrDetQty = row.item_detail.map(d => parseInt(d.qty));
          const optionWH = row.list_wh.map(wh => ({
            value: wh.value,
            label: wh.label,
            idWH: wh.helper,
            idSubWH: wh.helper2
          }));

          html.push(
            <tr key={`detail${i}`} className="border text-center">
              <td>{no++}.</td>
              <td style={{ textAlign: 'left', paddingLeft: '5px' }}>{row.name_item}</td>
              <td>{row.band_no}</td>

              {unit.map((nameUnit, p) => {
                const idx = arr.indexOf(nameUnit.value);
                return <td key={`unitTaking${p}`}>{idx >= 0 ? arrQty[idx] : 0}</td>;
              })}

              <td>{row.convert}</td>
              <td>{row.total_sell}</td>

              {unit.map((nameUnit, p) => {
                
                const bit = nameUnit.value;
                const bi = nameUnit.label;
                const idx = arrDet.indexOf(bit);
              
               
                return (
                  <td key={`unitItem${p}`}>
                    <div className="row pl-2">
                      <InputNumber
                        id={nameUnit?.label}
                        name={nameUnit?.label}
                        labelfield="false"
                        disabled={idx < 0}
                        defaultValue={0}
                        value={row['return']?.[p][bi]||0}
                        onValueChange={async (val, name) => {
                          const finalVal = val || 0;
                          // const key = `${row.index}_${bit}`;

                          // this.setState(prevState => ({
                          //   recordQtyMap: {
                          //     ...prevState.recordQtyMap,
                          //     [key]: val
                          //   }
                          // }));
                          // row.return = row.return.map(unitObj =>
                          //   unitObj.hasOwnProperty(bit) ? { ...unitObj, [bit]: finalVal } : unitObj
                          // );

                          await this.handlerInputArray(finalVal, name, row.index, 'arrayDetail', arrDetQty[idx], p, bit);
                        }}
                        className="form-control form-control-sm text-end"
                      />
                    </div>
                  </td>
                );
              })}

              <td>
                <div className="row pl-2">
                  <InputNumber
                    id="convertReturn"
                    name="convertReturn"
                    labelfield="false"
                    defaultValue={0}
                    value={row.convertReturn}
                    decimalsLimit={2}
                    disabled
                    onValueChange={() => {}}
                    className="form-control form-control-sm text-end"
                  />
                </div>
              </td>

              <td>
                <Select2
                  isClearable
                  name="warehouse"
                  required
                  className=""
                  size={4}
                  onChange={async (e, name) => {
                    await this.handlerSelectArray(e, name, row.index, "arrayDetail");
                  }}
                  options={optionWH}
                  title={i18n.t('Warehouse')}
                  value={row.warehouse}
                  placeholder={i18n.t('Select Warehouse')}
                  labelfield="false"
                />
                <div className="fv-plugins-message-container invalid-feedback">
                  {this.renderError(`${row.index}.warehouse`)}
                </div>
              </td>
            </tr>
          );
        });

        this.state.update = 1;
      }

      return html;
  }


  setList() {
    const { data } = this.props;
    let unit = this.state.unit;
    let html = [];
    let det = [];
    let itemdet = [];
    let no = 1;
    let itemUnit = [];
    for (var a = 0; a < unit.length; a++) {
      itemUnit.push({ id: unit[a].value })
    }
    if (data != null && data != '') {
      this.state.arrayDetail = data.return
      if (this.state.arrayDetail.length > 0) {
        for (var i = 0; i < this.state.arrayDetail.length; i++) {
          const row = this.state.arrayDetail[i];
          if (this.state.update == 0) {
            row['index'] = i;
            row['convertReturn'] = 0;
            row['return'] = [
              { Karton: 0, id: '' },
              { Bal: 0, id: '' },
              { Slop: 0, id: '' },
              { Pack: 0, id: '' },
              { Unit: 0, id: '' },
            ]
            row["cons"] = [];
            row["warehouse"] = [];
          }

          if (this.state.set == 0) {
            this.state.idSales = row.id_sales;
            this.state.idTakingGood = row.id;
            this.state.set = 1;
          }

          det = row.detail;
          itemdet = row.item_detail;
          let arr = [];
          let arrQty = [];
          let arrDet = [];
          let arrDetQty = [];
          let optionWH = [];

          for (var a = 0; a < det.length; a++) {
            arr.push(parseInt(det[a].id))
            arrQty.push(parseInt(det[a].qty))
          }

          for (var a = 0; a < row.list_wh.length; a++) {
            optionWH.push({ value: row.list_wh[a].value, label: row.list_wh[a].label, idWH: row.list_wh[a].helper, idSubWH: row.list_wh[a].helper2 })
          }

          for (var a = 0; a < itemdet.length; a++) {
            arrDet.push(parseInt(itemdet[a].idUnit))
            arrDetQty.push(parseInt(itemdet[a].qty))
          }

          html.push(
            <tr key={"detail" + i} className="border text-center">
              <td style={{ textAlign: 'center' }}>{no + '.'}</td>
              <td style={{ textAlign: 'left', paddingLeft:'5px' }}>{row.name_item}</td>
              <td>{row.band_no}</td>

              {unit.map((nameUnit, p) => {
                let bi = nameUnit.value
                let time = arr.indexOf(bi)
                return <td key={'unitTaking' + p}> {arr.indexOf(bi) >= 0 ? arrQty[time] : 0} </td>
              })}
              <td>{row.convert}</td>
              <td>{row.total_sell}</td>

              {unit.map((nameUnit, p) => {
                let bi = nameUnit.label
                let bit = nameUnit.value
                let time = arrDet.indexOf(bit)
                return <td key={'unitItem' + p}>
                  <div className="row">
                    <div className="pl-2">
                      <InputNumber
                        id={bi}

                        name={bi}
                        labelfield={"false"}
                        disabled={arrDet.indexOf(bit) >= 0 ? false : true}
                        defaultValue={0}
                        value={row['return'][p][bi]}
                        onValueChange={async (value, name) => {
                          if (value == null || value == '') {
                            value = 0
                          }
                          // this.setState({ qty: val });
                          await this.handlerInputArray(value, name, row['index'], 'arrayDetail', arrDetQty[time], p, bit);
                        }}
                        className="form-control  form-control-sm text-end"
                      />
                    </div>
                  </div>
                </td>
              })}
              <td >
                <div className="row">
                  <div className="pl-2">
                    <InputNumber
                      id={"convertReturn"}
                      name={"convertReturn"}
                      labelfield={"false"}
                      defaultValue={0}
                      value={row['convertReturn']}
                      decimalsLimit={2}
                      disabled={true}
                      onValueChange={(value, name) => { }}
                      className="form-control  form-control-sm text-end"
                    />
                  </div>
                </div>
              </td>
              <td>
                <Select2
                  isClearable={true}
                  name={'warehouse'}
                  required={true}
                  className={""}
                  size={4}
                  onChange={async (e, name) => {
                    await this.handlerSelectArray(e, name, row['index'], "arrayDetail");
                  }
                  }
                  options={optionWH}
                  title={i18n.t('Warehouse')}
                  value={row['warehouse']}
                  placeholder={i18n.t('Select Warehouse')}
                  labelfield={"false"}
                />
                <div className="fv-plugins-message-container invalid-feedback">
                  {this.renderError(row['index'] + ".warehouse")}
                </div>
              </td>
            </tr>
          );
          no++;
        }
        this.state.update = 1;
      }
    }
    return html;
  }

  setRetur() {
    const { data } = this.props;
    let html = [];
    let itemdet = [];

    let no = 1;
    let unit = this.state.unit;
    let itemUnit = [];
    for (var a = 0; a < unit.length; a++) {
      itemUnit.push({ id: unit[a].value })
    }

    if (data != null && data != '') {
      this.state.arrayRetur = data.retur
      this.state.dataRetur = data.item_retur

      if (this.state.arrayRetur.length > 0) {
        for (var i = 0; i < this.state.arrayRetur.length; i++) {
          const row = this.state.arrayRetur[i];
          if (this.state.updateRetur == 0) {
            row['index'] = i;
            row['convertRetur'] = 0;
            row['retur'] = [
              { Karton: 0, id: '' },
              { Bal: 0, id: '' },
              { Slop: 0, id: '' },
              { Pack: 0, id: '' },
              { Unit: 0, id: '' },
            ]
            row["cons"] = [];
            row["warehouse"] = [];
          }

          // if (this.state.set == 0) {
          //   this.state.idSales = row.id_sales;
          //   this.state.idTakingGood = row.id;
          //   this.state.set = 1;
          // }

          // det = row.detail;
          itemdet = row.item_detail;
          // let arr = [];
          // let arrQty = [];
          let arrDet = [];
          let arrDetQty = [];
          let optionWH = [];

          // for (var a = 0; a < det.length; a++) {
          //   arr.push(parseInt(det[a].id))
          //   arrQty.push(parseInt(det[a].qty))
          // }

          for (var a = 0; a < row.list_wh.length; a++) {
            optionWH.push({ value: row.list_wh[a].value, label: row.list_wh[a].label, idWH: row.list_wh[a].helper, idSubWH: row.list_wh[a].helper2 })
          }

          for (var a = 0; a < itemdet.length; a++) {
            arrDet.push(parseInt(itemdet[a].idUnit))
            arrDetQty.push(parseInt(itemdet[a].qty))
          }

          // if(row.length > 0){
          //   for(var i=0; i< row.length; i++){
          //     let optionWH = [];
          //     if (this.state.updateRetur == 0) {
          //       row[i]['index'] = i;
          //       row[i]['convertReturn'] = 0;
          //       row[i]['retur'] = [{
          //         Bal: 0, id: ''
          //       },
          //       { Karton: 0, id: '' },
          //       { Slop: 0, id: '' },
          //       { Pack: 0, id: '' },
          //       { Unit: 0, id: '' },
          //       ]
          //       row[i]["cons"] = [];
          //       row[i]["warehouse"] = [];
          //     }
          //     for (var a = 0; a < row[i].list_wh.length; a++) {
          //       optionWH.push({ 
          //         value: row[i].list_wh[a].value, 
          //         label: row[i].list_wh[a].label, 
          //         idWH: row[i].list_wh[a].helper, 
          //         idSubWH: row[i].list_wh[a].helper2 })
          //     }

          //     itemdet = row[i].item_detail;
          //     let arrDet = [];
          //     for (var a = 0; a < itemdet.length; a++) {
          //       arrDet.push(parseInt(itemdet[a].idUnit))
          //       // arrDetQty.push(parseInt(itemdet[a].qty))
          //     }

          html.push(
            <tr key={"detail-retur" + i} className="border text-center">
              <td style={{ textAlign: 'center' }}>{no + '.'}</td>
              <td>{row.name_item}</td>
              <td style={{ textAlign: 'right', paddingRight: '10px' }}>{row.qty_good}</td>
              <td style={{ textAlign: 'right', paddingRight: '10px' }}>{row.qty_bad}</td>
              {unit.map((nameUnit, p) => {
                let bi = nameUnit.label
                let bit = nameUnit.value
                let time = arrDet.indexOf(bit)
                return <td key={'unitItem' + p}>
                  <div className="row">
                    <div className="pl-2">
                      <InputNumber
                        id={bi}

                        name={bi}
                        labelfield={"false"}
                        disabled={arrDet.indexOf(bit) >= 0 ? false : true}
                        defaultValue={0}
                        value={row['retur'][p][bi]}
                        onValueChange={async (value, name) => {
                          if (value == null || value == '') {
                            value = 0
                          }
                          await this.handlerInputArrayRetur(value, name, row['index'], 'arrayRetur', arrDetQty[time], p, bit);
                        }}
                        className="form-control  form-control-sm text-end"
                      />
                    </div>
                  </div>
                </td>
              })}
              <td >
                <div className="row">
                  <div className="pl-2">
                    <InputNumber
                      id={"convertRetur"}
                      name={"convertRetur"}
                      labelfield={"false"}
                      defaultValue={0}
                      value={row['convertRetur']}
                      decimalsLimit={2}
                      disabled={true}
                      onValueChange={(value, name) => { }}
                      className="form-control  form-control-sm text-end"
                    />
                  </div>
                </div>
              </td>
              <td>
                <Select2
                  isClearable={true}
                  name={'warehouse'}
                  required={true}
                  className={""}
                  size={4}
                  onChange={async (e, name) => {
                    await this.handlerSelectArray(e, name, row['index'], "arrayRetur");
                  }
                  }
                  options={optionWH}
                  title={i18n.t('Warehouse')}
                  value={row['warehouse']}
                  placeholder={i18n.t('Warehouse')}
                  labelfield={"false"}
                />
                <div className="fv-plugins-message-container invalid-feedback">
                  {this.renderError(row['index'] + ".warehouse")}
                </div>
              </td>
            </tr>
          );
        }
      }
      this.state.updateRetur = 1;
    }
    return html;
  }

  render() {
    const { data, isNewRecord, isProcessing, helperTakingGoods } = this.props;
    let unit = [];
    let col = [];
    if (data != null) {
      let total = 0;
      col = data.return[0];
      if (data.return != null && this.state.add == 0) {
        for (var i = 0; i < data.return.length; i++) {
          this.state.arrayTotal.push({
            id: data.return[i].id_item, qty: data.return[i].convert
          })
        }
      }

      // if(data.retur != null && this.state.add == 0){
      //   for(var i=0; i<data.retur.length;i++){
      //     let index =  this.state.arrayTotal.findIndex((item) => item.id === data.retur[i].id_item);
      //     if(index > -1){
      //       const arrQty =  this.state.arrayTotal[index];
      //       total = arrQty['qty'] + data.retur[i].convert
      //       arrQty['qty'] = total
      //     }else{
      //     this.state.arrayTotal.push({
      //       id:data.retur[i].id_item,qty:data.retur[i].convert})
      //     }
      //   }
      // }
      // this.state.add = 1;
    }

    if (helperTakingGoods != null) {
      this.state.branchList = helperTakingGoods != null ? helperTakingGoods.branch : [];
      this.state.unit = helperTakingGoods.unit;
      unit = helperTakingGoods.unit;
      if (this.state.show == false) {
        this.state.show = true;
      }
    }

    return (
      <React.Fragment>
        {(!isProcessing) ?
          <form>
            {/* <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-fluid">
              <div className="flex-row-fluid" id="kt_content">
                <div className="card">
                  <div className="card-body " > */}
                    <div class="max-w-6xl mx-auto bg-white shadow-lg rounded-xl p-6 space-y-4">
                      <div class="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                        <div class="flex justify-between text-sm text-gray-700 flex-wrap gap-y-2">
                          <div className="row" style={{ fontSize: '16px' }}>
                            <div className="col">
                              <p><strong>{i18n.t('Date')} : </strong>{col.date}</p>
                              <p><strong>{i18n.t('Branch')} : </strong>{col.name_branch}</p> 
                              <p><strong>{i18n.t('Store')} : </strong>{col.name_store}</p>
                            </div>
                            <div className="col">
                              <p><strong>{i18n.t('Taking Goods No.')} : </strong>{col.no_tr}</p>
                              <p><strong>{i18n.t('Sales Name')} : </strong>{col.name_sales}</p>
                              <p><strong>{i18n.t('Warehouse Origin')} : </strong>{col.name_wh} {col.name_sub_wh}</p>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row" >
                          <div className="col-12 " style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {i18n.t("Return Date")}
                          </div>
                        </div>
                        <div className="row" >
                          <div className="col-3 mt-3">
                            <DatePickerCustom
                              name={"dateReturn"}
                              title={i18n.t("")}
                              required={false}
                              selected={this.state.dateReturn}
                              onSelect={async (e) => {
                                await this.handlerDateTime(e, 'dateReturn');
                              }
                              }
                              startDay={0}
                              autoComplete={"off"}
                              dateFormat="dd MMMM yyyy"
                              maxDate={new Date()}
                              className="form-control form-control-sm font-weight-bold"
                            />
                          </div>
                        </div>
                        <br />
                        <div className="row" >
                          <div className="col-12">
                            <Table striped bordered hover className="border" style={{ fontWeight: 'bold' }}>
                              <thead>
                                <tr className="border" style={{ backgroundColor: '#68829E', color: 'white' }}>
                                  <th width={"3%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No.")}</th>
                                  <th width={"15%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Item")}</th>
                                  <th width={"8%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No. Band")}</th>
                                  <th width={"25%"} className="text-center" colSpan={(unit.length + 1)}>{i18n.t("Taking")}</th>
                                  <th width={"8%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Selling (Pack)")}</th>

                                  <th width={"25%"} className="text-center" colSpan={(unit.length + 1)}>{i18n.t("Return")}</th>
                                  <th width={"20%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Warehouse")}</th>
                                </tr>
                                <tr className="border">

                                  {(unit.length > 0) ?
                                    unit.map((header, i) => {
                                      return <th key={"header" + i} width={"5%"} className="text-center " style={{ backgroundColor: '#68829E', color: 'white' }} >{header.label}</th>
                                    })
                                    : null}
                                  <th key={"headerConvert"} width={"5%"} className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Convert (Pack)")}</th>


                                  {(unit.length > 0) ?
                                    unit.map((header, i) => {
                                      return <th key={"headerReturn" + i} width={"5%"} className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{header.label}</th>
                                    })
                                    : null}
                                  <th key={"headerConvert1"} width={"8%"} className="text-center" style={{ backgroundColor: '#68829E', color: 'white' }}>{i18n.t("Convert (Pack)")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.show == true ? this.setNewList() : null}
                              </tbody>
                            </Table>
                          </div>
                        </div>


                      
                        {/* <div className="row" >
                      <div className="col-12" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {i18n.t("Item Retur")}
                      </div>
                    </div>
                    <div className="row" >
                      <div className="col-12" >
                        <Table striped bordered hover className="border" style={{ fontWeight: 'bold' }}>
                          <thead>
                          <tr className="border" style={{ backgroundColor: '#68829E' , color:'white' }}>
                              <th width={"3%"} className="text-center pb-10" rowSpan={2}>{i18n.t("No.")}</th>
                              <th width={"20%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Item")}</th>
                              <th width={"10%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Good Stock (Pack)")}</th>
                              <th width={"10%"} className="text-center pb-10" rowSpan={2}>{i18n.t("Bad Stock (Pack)")}</th>
                              <th width={"32%"} className="text-center" colSpan={(unit.length + 1)}>{i18n.t("Return (Good Stock)")}</th>
                              <th width={"30  %"} className="text-center pb-10" rowSpan={2}>{i18n.t("Warehouse")}</th>
                            </tr>
                            <tr className="border">
                                {(unit.length > 0) ?
                                  unit.map((header, i) => {
                                    return <th key={"headerReturn" + i} width={"5%"} className="text-center" style={{ backgroundColor: '#68829E', color:'white' }}>{header.label}</th>
                                  })
                                  : null}
                                <th key={"headerConvert1"} width={"8%"} className="text-center" style={{ backgroundColor: '#68829E' , color:'white' }}>{i18n.t("Convert (Pack)")}</th>
                                </tr>
                          </thead>
                          <tbody>
                            {this.state.show == true ? this.setRetur() : null}
                          </tbody>
                        </Table>
                      </div>
                    </div> */}
                      </div>
                    </div>
                  {/* </div>
                </div>
              </div>
            </div> */}
          </form>
          :
          <div className="text-center">
            <div className="spinner-border  text-primary text-center  clearfix"></div>
            <div className="text-center">{i18n.t("Loading")}</div>
          </div>}
      </React.Fragment>
    );
  }
}

export default FormReturn;
